import $ from "jquery";
import { $subscriber } from "fire-wind-water";

function formatSBase(cmd, data) {
  var sBase = {
      size: 0,
      orn: "02-0001-00000001",
      dst: "01-0401-00000001",
      type: 0x0002,
      cmd: cmd,
      sess: undefined,
      seq: 0,
      ver: 1000,
      body: data
    },
    schemaId = "";
  if (schemaId) {
    var cookie = $.cookie("smarketMember_" + schemaId);
    if (cookie && cookie.session && cookie.session !== "null") {
      sBase.sess = cookie.session;
    }
  }

  return sBase;
}

let socketModule = {
  url: "",
  option: null,
  socket: undefined,
  isOn: null,
  user: undefined,
  webinar: undefined,
  init: function(url, options) {
    var self = this;
    self.url = url;
    self.options = $.extend({}, options);
    self.socket = undefined;
    self.user = undefined;
    self.webinar = undefined;
  },
  emit: function(cmd, data, ack) {
    var self = this;
    var body = {
      head: $.extend({}, self.user, {
        userid: self.user.id,
        isNewRecognition: 1,
        webinarId: self.webinar.webinarId,
        webcastid: self.webinar.webcastId
      }),
      data: data || {}
    };
    self.socket.emit("emitSocket", formatSBase(cmd, body), ack);
  },
  connect: function(user, webinar, callback) {
    var self = this,
      events = [
        "disconnect",
        "reconnect",
        "reconnect_attempt",
        "reconnecting",
        "reconnect_error",
        "reconnect_failed",
        "connect_error",
        "connect_timeout",
        "connecting",
        "ping",
        "pong",
        "onEmitSocket"
        // , 'error'
      ];

    self.socket = window.io.connect(self.url, self.options);

    self.user = user;
    self.webinar = webinar;
    $.each(events, function(i, event) {
      self.socket.on(event, function(data) {
        console.log("event", event);
        $subscriber.emit(event, data);
      });
    });
    self.socket.on("connect", () => {
      $subscriber.emit("connect", "1");
    });
    $subscriber.onic("connect", function() {
      console.log("用户已连接");
      self.emit(
        "onUserJoin",
        {
          clientType: user.clientType,
          company: user.company,
          deviceType: user.deviceInfo,
          email: user.email,
          mobile: user.mobile,
          position: user.position,
          role: "0",
          systemInfo: user.systemInfo,
          userName: user.name,
          userid: user.id,
          nickName: user.nickName,
          avatar: user.avatar
        },
        function(data) {
          if (callback && typeof callback == "function") {
            callback();
          }
          console.log(data);
        }
      );
      self.isOn = true;
      self.emit("onlineNumber");
      self.emit("onVote");
      self.emit("onQuestionnaire");
      self.emit("onTimelineSingle");
    });
    $subscriber.on("reconnect", function() {
      console.log("用户已重新连接");
    });
    $subscriber.on("disconnect", function() {
      console.log("用户已断开");
    });
    $subscriber.on("error", function(err) {
      console.log(err);
    });

    $subscriber.on("onEmitSocket", function(event) {
      console.log(event);
      $subscriber.emit(event.cmd, event.body.content.data);
    });
  },
  disconnect: function() {
    var self = this;
    try {
      console.log(self);
      console.log("主动断开连接销毁时间】】");
      self.isOn = null;
      $subscriber.off("onEmitSocket");
      $subscriber.off("connect");
      $subscriber.off("webinarInfo.meeting");
      $subscriber.off("onKickout");
      $subscriber.off("kickOut");
      self.socket.disconnect();
    } catch (e) {
      console.log("断开连接失败");
    }
  },
  disconnect_connect: function() {
    //为了区别内置方法reconnect, 这个短线重连是主动调disconnect和connect，各1次。
    var self = this;
    self.disconnect();
    self.connect(self.user, self.webinar);
  },
  onSetUserInfo: function(user) {
    var self = this;
    self.emit(
      "onSetUserInfo",
      {
        userName: user.name,
        avatar: user.avatar
      },
      function(data) {
        console.log(data);
      }
    );
    //gensee
    if (window.channel) {
      window.channel.send("submitUsername ", {
        name: user.name
      });
    }
  }
};
export { socketModule };
